import React,{Suspense,lazy} from "react";
import {Routes,Route} from "react-router-dom";


const Resparser = lazy(() => import('./pages/resparser/resparser'));
const PageNotFound = lazy(() => import('./pages/pagenotfound/pagenotfound'))


function App(){
  return (
    <>
      <Suspense fallback={<p>Loading...</p>}>
      <Routes>
        <Route path="/:id" element={<Resparser />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      </Suspense>
    </>
  )
}

export default App;